import { render } from "./FullTrainingView.vue?vue&type=template&id=67d9ec7e"
import script from "./FullTrainingView.vue?vue&type=script&lang=js"
export * from "./FullTrainingView.vue?vue&type=script&lang=js"

import "./FullTrainingView.vue?vue&type=style&index=0&id=67d9ec7e&lang=scss"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__